<template>
  <div class="pg-drawer-serial-select">
    <div v-if="visible">
      <Drawer
        custom-class="pg-drawer-serial-select-form"
        :title="props.title"
        :size="props.width"
        visible
        :append-to-body="appendToBody"
        @close="closeDrawer"
      >
        <div class="pg-drawer-serial-select-form__content">
          <div class="pg-drawer-serial-select-form__content--form">
            <PgForm
              :formItemsCode="props.formItemsCode"
              :extendCompileData="{ parentData: props.formData }"
              :model="clone(props.row)"
            >
            </PgForm>
            <PgScanUpdateItems
              class="pg-drawer-serial-select-form__content--scan"
              itemsUrl="/rest/main/store/storageItem/queryAdvanceMapToEntity"
              :columnTableCode="columnTableCode"
              :current-list="
                props.value
                  ? props.value
                  : getValueByPath(props.row, valKey)
                  ? [getValueByPath(props.row, valKey)]
                  : []
              "
              :isEpc="isEpc"
              :valKey="valKey"
              :scanPlaceholder="scanPlaceholder"
              :searchPlaceholder="searchPlaceholder"
              :formModel="clone(props.row)"
              :itemsParameters="itemsParametersac"
              isSelection
              @input="onInput"
            >
            </PgScanUpdateItems>
          </div>
        </div>
        <div class="pg-drawer-serial-select-form__footer">
          <ElButton type="primary" round @click="onOk" :loading="loading">确定</ElButton>
        </div>
      </Drawer>
    </div>
    <div class="serial-select" @click="openDrawer">
      <span v-if="disabled && !data.btnSerialText">-</span>
      <span v-if="data.btnSerialText" style="margin-right: 6px">{{ data.btnSerialText }}</span>
      <span class="serial-span" v-if="!disabled">{{ props.btnText }}</span>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, watch, getCurrentInstance, computed } from 'vue'
import {
  clone,
  getValueByPath,
  // isEqual
} from 'pangu-core'
import { Drawer } from 'element-ui'
import { beforValueOldActionProps, useBeforValueOldActions } from '../../../hooks/index'
import { PgForm } from '../../form/index'
import { PgScanUpdateItems } from '../../scan-update-items/index'

const emit = defineEmits(['input'])
const { proxy } = getCurrentInstance()
const props = defineProps({
  value: {
    type: Array,
    default() {
      return []
    },
  },
  formData: {
    type: Object,
    default() {
      return {}
    },
  },
  row: {
    type: Object,
    default() {
      return {}
    },
  },
  appendToBody: {
    type: Boolean,
    default: true,
  },
  dataKeepingKey: { type: String, default: 'goodsKeeping' },
  formItemsCode: { type: String },
  width: { type: [String, Number], default: 720 },
  title: { type: String, default: '选择序列号' },
  btnText: { type: String, default: '选择' },
  isEpc: Boolean,
  scanPlaceholder: String,
  searchPlaceholder: String,
  itemsParameters: Object,
  columnTableCode: {
    type: String,
    default: 'UNION_SELECT_SERIAL_NUMBER_ITEMS_TABLE',
  },
  disabled: Boolean,
  ...beforValueOldActionProps,
})
const { loading, beforeEmit } = useBeforValueOldActions({
  store: props.store,
  beforValueAction: props.beforValueAction,
  emit,
})

const itemsParametersac = computed(() => {
  let parameters = Object.assign(
      {
        gtValue: 0,
        serialNumberLength: 0,
        batchNumber: getValueByPath(props.row, 'goodsKeeping.batchNumber', []),
        items: getValueByPath(props.formData, 'items', []),
        targetId: getValueByPath(props.formData, 'order.target.organization.id', ''),
        logisticsId: getValueByPath(props.formData, 'order.source.logistics.id', ''),
        warehouseId: getValueByPath(props.formData, 'order.source.warehouse.id', ''),
      },
      props.itemsParameters?.parameters
    ),
    otherParams = props.itemsParameters
  if (otherParams && 'parameters' in otherParams) delete otherParams.parameters
  return {
    criteriaCode: 'ISCC_BATCH_NUMBER_QUERY_SHOW_STATUS_INVENTORY',
    parameters,
    ...otherParams,
  }
})

const data = reactive({
  btnSerialText: null,
  selected: null,
  items: [],
})

const visible = ref(false)
const openDrawer = () => {
  if (!props.disabled) {
    visible.value = true
  }
}
const closeDrawer = () => {
  visible.value = false
}

const valKey = computed(() => (props.isEpc ? 'epc' : `${props.dataKeepingKey}.serialNumber`))

const getSerialNumbers = () => {
  const serialNumbers = [...new Set(data.items.map((im) => getValueByPath(im, valKey.value)))]

  return serialNumbers
}

const onInput = ({ selected, items }) => {
  data.selected = selected
  data.items = items
}
const onOk = async () => {
  // 对外抛出数据，可供其他页面/组件使用
  const options = {
    data: getSerialNumbers(),
    extendData: {
      items: data.items,
      row: props.row,
    },
    vue: proxy,
  }

  // 兼容老组件的 beforValueAction 执行 beforeEmit，内部处理完后对外抛出 input 事件和值
  const flag = await beforeEmit(options)
  console.log('如果 flag 的值为 false 则不关闭侧滑', !!flag, flag)
  if (flag) closeDrawer()
}

watch(
  () => props.value,
  (val, oldValue) => {
    let value = val
    if (!val?.length) {
      value = getValueByPath(props.row, valKey.value)
        ? [getValueByPath(props.row, valKey.value)]
        : []
    }

    console.log('props.value: ', val)
    console.log('value: ', value)
    console.log('oldValue: ', oldValue)
    if (value?.length) {
      data.btnSerialText = value.length === 1 ? value?.[0] : value.length + '条'
    } else {
      data.btnSerialText = null
    }
    // 如果值改变了则关闭侧滑
    // if (!isEqual(value, oldValue)) closeDrawer()
  },
  { immediate: true }
)
</script>

<style lang="scss">
@import '../style/drawer-serial-select.scss';
</style>
